import { __awaiter, __generator, __read, __spreadArray } from "tslib";
import { WORKSPACE_ID } from '@office-start/app-gallery-types';
import { HubTileID } from '@office-start/appbar-types';
import { fetchCapabilities } from '@office-start/capabilities-service';
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { getHubTileIdFromFirstPartyWorkloadId, getSanitizedAppId, m365AppPlatformType, onedriveMOSAppId, } from '@office-start/data-resolver-app-pinning';
import { FileType } from '@office-start/document-types';
import { fetchFeatureGates } from '@office-start/feature-gates-service';
import { fetchFeatureSettings } from '@office-start/feature-settings-service';
import { getTypeFromFileTypeName } from '@office-start/file-utility';
import { getLaunchInstrumentationParamsFromKnownArea, launchApp, launchUrl, } from '@office-start/launcher-service';
import { OfficeRouteItemType, OfficeWorkload, } from '@office-start/officehome-types';
import { fetchThirdPartyWorkloads, fetchWorkloads, } from '@office-start/workloads-service';
import { fetchWorkspaces } from '@office-start/workspaces-service';
var internalPlatformTypes = [m365AppPlatformType];
var routeMap = {};
routeMap[HubTileID.home] = {
    route: 'OfficeHome',
    type: OfficeRouteItemType.Base,
};
routeMap[HubTileID.create] = {
    route: 'Create',
    type: OfficeRouteItemType.Base,
};
routeMap[HubTileID.mycontent] = {
    route: 'MyContent',
    type: OfficeRouteItemType.Base,
};
routeMap[HubTileID.chat] = {
    route: 'Chat',
    type: OfficeRouteItemType.Base,
};
routeMap[HubTileID.browse] = {
    route: 'Browse',
    type: OfficeRouteItemType.Base,
};
routeMap[HubTileID.catchUp] = {
    route: 'CatchUp',
    type: OfficeRouteItemType.Base,
};
routeMap[HubTileID.collect] = {
    route: 'Collect',
    type: OfficeRouteItemType.Base,
};
routeMap[HubTileID.prepare] = {
    route: 'Prepare',
    type: OfficeRouteItemType.Base,
};
routeMap[HubTileID.news] = {
    route: 'News',
    type: OfficeRouteItemType.Base,
};
routeMap[HubTileID.peopleAIHub] = {
    route: 'People',
    type: OfficeRouteItemType.Base,
};
routeMap[HubTileID.assist] = {
    route: 'Assist',
    type: OfficeRouteItemType.Base,
};
routeMap[HubTileID.automate] = {
    route: 'Automate',
    type: OfficeRouteItemType.Base,
};
routeMap[HubTileID.orion] = {
    route: 'Orion',
    type: OfficeRouteItemType.Base,
};
routeMap[HubTileID.feed] = {
    route: 'Feed',
    type: OfficeRouteItemType.Base,
};
routeMap[HubTileID.appgallery] = {
    route: 'AppGallery',
    type: OfficeRouteItemType.Base,
};
routeMap[HubTileID.alps] = {
    route: 'Alps',
    type: OfficeRouteItemType.Base,
};
routeMap[HubTileID.copilotCmc] = {
    route: 'CopilotCmc',
    type: OfficeRouteItemType.Base,
};
routeMap[HubTileID.word] = {
    route: 'Start',
    type: OfficeRouteItemType.Base,
    app: FileType.Word,
};
routeMap[HubTileID.excel] = {
    route: 'Start',
    type: OfficeRouteItemType.Base,
    app: FileType.Excel,
};
routeMap[HubTileID.powerpoint] = {
    route: 'Start',
    type: OfficeRouteItemType.Base,
    app: FileType.PowerPoint,
};
routeMap[HubTileID.onenote] = {
    route: 'Start',
    type: OfficeRouteItemType.Base,
    app: FileType.OneNote,
};
routeMap[HubTileID.sway] = {
    route: 'Start',
    type: OfficeRouteItemType.Base,
    app: FileType.Sway,
};
routeMap[HubTileID.forms] = {
    route: 'Start',
    type: OfficeRouteItemType.Base,
    app: FileType.Forms,
};
routeMap[HubTileID.visio] = {
    route: 'Start',
    type: OfficeRouteItemType.Base,
    app: FileType.Visio,
};
routeMap[HubTileID.stream] = {
    route: 'Start',
    type: OfficeRouteItemType.Base,
    app: FileType.Stream,
};
routeMap[HubTileID.clipchamp] = {
    route: 'Start',
    type: OfficeRouteItemType.Base,
    app: FileType.Clipchamp,
};
routeMap[HubTileID.aiHubSample] = {
    route: 'AiHubSample',
    type: OfficeRouteItemType.Base,
};
export function isExternalModule(id, platformType) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var context, featureGates, route, capabilities, fileType, workloads, workload;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, fetchOfficeComponentContext()];
                case 1:
                    context = _d.sent();
                    if (!(platformType && internalPlatformTypes.includes(platformType))) return [3 /*break*/, 2];
                    // The apps from these platform types should never launch out
                    return [2 /*return*/, false];
                case 2:
                    if (!(id === HubTileID.collect &&
                        context.workload == OfficeWorkload.Hwa)) return [3 /*break*/, 3];
                    return [2 /*return*/, true];
                case 3:
                    if (!(id === HubTileID.onedrive)) return [3 /*break*/, 5];
                    return [4 /*yield*/, fetchFeatureGates()];
                case 4:
                    featureGates = _d.sent();
                    return [2 /*return*/, ((_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _a === void 0 ? void 0 : _a.oneDriveMosAppGates) === null || _b === void 0 ? void 0 : _b.oneDriveMosAppEnabled)
                            ? false
                            : true];
                case 5:
                    if (!routeMap[id]) return [3 /*break*/, 8];
                    route = routeMap[id];
                    if (route.route !== 'Start') {
                        return [2 /*return*/, false];
                    }
                    return [4 /*yield*/, fetchCapabilities()];
                case 6:
                    capabilities = _d.sent();
                    fileType = getTypeFromFileTypeName(route.app);
                    if (!fileType || !((_c = capabilities === null || capabilities === void 0 ? void 0 : capabilities.startPageApps) === null || _c === void 0 ? void 0 : _c.has(fileType))) {
                        // This start page is not enabled, so we launch out
                        return [2 /*return*/, true];
                    }
                    return [4 /*yield*/, getFirstPartyWorkloads()];
                case 7:
                    workloads = _d.sent();
                    workload = workloads.find(function (workload) {
                        return getHubTileIdFromFirstPartyWorkloadId(workload.AppId) === id;
                    });
                    return [2 /*return*/, !(workload === null || workload === void 0 ? void 0 : workload.InAppNav)];
                case 8: 
                // By default, apps should try to launch out
                return [2 /*return*/, true];
            }
        });
    });
}
export function launchModuleById(id, platformType, eventType, launchOut, additionalParams) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var featureGates, featureSettings, route, action, launchInstrumentationParams, key, context, action_1, isExternal, hubInfo, url;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, fetchFeatureGates()];
                case 1:
                    featureGates = _c.sent();
                    return [4 /*yield*/, fetchFeatureSettings()];
                case 2:
                    featureSettings = _c.sent();
                    route = translateTileToRoute(id, platformType, featureGates.result, featureSettings.result);
                    action = 'OpenInBrowser';
                    launchInstrumentationParams = getLaunchInstrumentationParamsFromKnownArea('AppBar', eventType, getSanitizedAppId(id, platformType), launchOut);
                    if (additionalParams) {
                        // Copy additional parameters into the click params
                        for (key in additionalParams) {
                            launchInstrumentationParams.clickParams[key] =
                                additionalParams[key];
                        }
                    }
                    if (!!launchOut) return [3 /*break*/, 4];
                    return [4 /*yield*/, launchUrl(route, { action: action }, launchInstrumentationParams)];
                case 3:
                    _c.sent();
                    return [3 /*break*/, 12];
                case 4: return [4 /*yield*/, fetchOfficeComponentContext()];
                case 5:
                    context = _c.sent();
                    action_1 = 'OpenInBrowser';
                    return [4 /*yield*/, isExternalModule(id, platformType)];
                case 6:
                    isExternal = _c.sent();
                    if (!isExternal) return [3 /*break*/, 10];
                    return [4 /*yield*/, getHubUrlOrAppName(id)];
                case 7:
                    hubInfo = _c.sent();
                    if (!hubInfo) return [3 /*break*/, 9];
                    return [4 /*yield*/, launchApp({ action: action_1, appName: hubInfo.appName, url: hubInfo.url }, launchInstrumentationParams)];
                case 8:
                    _c.sent();
                    _c.label = 9;
                case 9: return [3 /*break*/, 12];
                case 10:
                    url = (_b = context === null || context === void 0 ? void 0 : (_a = context.router).getUrlForRoute) === null || _b === void 0 ? void 0 : _b.call(_a, route);
                    if (!url) return [3 /*break*/, 12];
                    return [4 /*yield*/, launchUrl(url, { action: action_1 }, launchInstrumentationParams)];
                case 11:
                    _c.sent();
                    _c.label = 12;
                case 12: return [2 /*return*/];
            }
        });
    });
}
function translateTileToRoute(tileID, platformType, featureGates, featureSettings) {
    var _a, _b, _c;
    if (tileID === HubTileID.copilotMos &&
        ((_a = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.copilot) === null || _a === void 0 ? void 0 : _a.mode) === 'ModeB') {
        return {
            route: 'Chat',
            type: OfficeRouteItemType.Base,
        };
    }
    else if (platformType === m365AppPlatformType) {
        return {
            route: 'M365Apps',
            type: OfficeRouteItemType.Mos,
            appId: tileID,
        };
    }
    else if (tileID === HubTileID.onedrive &&
        ((_b = featureGates === null || featureGates === void 0 ? void 0 : featureGates.oneDriveMosAppGates) === null || _b === void 0 ? void 0 : _b.oneDriveMosAppEnabled)) {
        return {
            route: 'M365Apps',
            type: OfficeRouteItemType.Mos,
            appId: onedriveMOSAppId,
        };
    }
    else {
        return ((_c = routeMap[tileID]) !== null && _c !== void 0 ? _c : {
            route: 'OfficeHome',
            type: OfficeRouteItemType.Base,
        });
    }
}
function getFirstPartyWorkloads() {
    return __awaiter(this, void 0, void 0, function () {
        var workloads;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchWorkloads()];
                case 1:
                    workloads = _a.sent();
                    return [2 /*return*/, __spreadArray(__spreadArray([], __read(((workloads === null || workloads === void 0 ? void 0 : workloads.coreAndSegmentApps) || [])), false), __read(((workloads === null || workloads === void 0 ? void 0 : workloads.nonCoreAndSegmentApps) || [])), false)];
            }
        });
    });
}
function getHubUrlOrAppName(tileID) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    return __awaiter(this, void 0, void 0, function () {
        var hubInfo, links, _v, url, thirdPartyWorkloads, workspaces, allAppsWorkspace;
        return __generator(this, function (_w) {
            switch (_w.label) {
                case 0: return [4 /*yield*/, getFirstPartyWorkloads()];
                case 1:
                    links = _w.sent();
                    _v = tileID;
                    switch (_v) {
                        case HubTileID.outlook: return [3 /*break*/, 2];
                        case HubTileID.onedrive: return [3 /*break*/, 3];
                        case HubTileID.teams: return [3 /*break*/, 4];
                        case HubTileID.onenote: return [3 /*break*/, 5];
                        case HubTileID.sway: return [3 /*break*/, 6];
                        case HubTileID.todo: return [3 /*break*/, 7];
                        case HubTileID.familysafety: return [3 /*break*/, 8];
                        case HubTileID.calendar: return [3 /*break*/, 9];
                        case HubTileID.skype: return [3 /*break*/, 10];
                        case HubTileID.people: return [3 /*break*/, 11];
                        case HubTileID.powerautomate: return [3 /*break*/, 12];
                        case HubTileID.clipchamp: return [3 /*break*/, 13];
                        case HubTileID.lists: return [3 /*break*/, 14];
                        case HubTileID.admin: return [3 /*break*/, 15];
                        case HubTileID.copilotExternal: return [3 /*break*/, 16];
                        case HubTileID.collect: return [3 /*break*/, 17];
                    }
                    return [3 /*break*/, 18];
                case 2:
                    hubInfo = {
                        url: ((_a = links.find(function (link) { return link.Id === "ShellMail" /* FirstPartyWorkloadIds.Outlook */; })) === null || _a === void 0 ? void 0 : _a.Url) || '',
                        appName: 'outlook',
                    };
                    return [3 /*break*/, 23];
                case 3:
                    hubInfo = {
                        url: ((_b = links.find(function (link) { return link.Id === "ShellDocuments" /* FirstPartyWorkloadIds.OneDrive */; })) === null || _b === void 0 ? void 0 : _b.Url) || '',
                        appName: '',
                    };
                    return [3 /*break*/, 23];
                case 4:
                    hubInfo = {
                        url: ((_c = links.find(function (link) {
                            return link.Id === "ShellSkypeTeams" /* FirstPartyWorkloadIds.Teams */ ||
                                link.Id === "ShellTeams" /* FirstPartyWorkloadIds.TeamsForLife */;
                        })) === null || _c === void 0 ? void 0 : _c.Url) || '',
                        appName: '', // At the moment, the HWA bridge doesn't seem to support opening the Teams native app
                    };
                    return [3 /*break*/, 23];
                case 5:
                    hubInfo = {
                        url: ((_d = links.find(function (link) { return link.Id === "ShellOneNoteOnline" /* FirstPartyWorkloadIds.OneNote */; })) === null || _d === void 0 ? void 0 : _d.Url) || '',
                        appName: 'onenote',
                    };
                    return [3 /*break*/, 23];
                case 6:
                    hubInfo = {
                        url: ((_e = links.find(function (link) { return link.Id === "ShellSway" /* FirstPartyWorkloadIds.Sway */; })) === null || _e === void 0 ? void 0 : _e.Url) || '',
                        appName: '',
                    };
                    return [3 /*break*/, 23];
                case 7:
                    hubInfo = {
                        url: ((_f = links.find(function (link) { return link.Id === "ShellToDo" /* FirstPartyWorkloadIds.ToDo */; })) === null || _f === void 0 ? void 0 : _f.Url) || '',
                        appName: '',
                    };
                    return [3 /*break*/, 23];
                case 8:
                    hubInfo = {
                        url: ((_g = links.find(function (link) {
                            return link.Id === "ShellFamilySafety" /* FirstPartyWorkloadIds.FamilySafety */;
                        })) === null || _g === void 0 ? void 0 : _g.Url) || '',
                        appName: '',
                    };
                    return [3 /*break*/, 23];
                case 9:
                    hubInfo = {
                        url: ((_h = links.find(function (link) { return link.Id === "ShellCalendar" /* FirstPartyWorkloadIds.Calendar */; })) === null || _h === void 0 ? void 0 : _h.Url) || '',
                        appName: '',
                    };
                    return [3 /*break*/, 23];
                case 10:
                    hubInfo = {
                        url: ((_j = links.find(function (link) { return link.Id === "ShellSkype" /* FirstPartyWorkloadIds.Skype */; })) === null || _j === void 0 ? void 0 : _j.Url) || '',
                        appName: '',
                    };
                    return [3 /*break*/, 23];
                case 11:
                    hubInfo = {
                        url: ((_k = links.find(function (link) { return link.Id === "ShellPeople" /* FirstPartyWorkloadIds.People */; })) === null || _k === void 0 ? void 0 : _k.Url) || '',
                        appName: '',
                    };
                    return [3 /*break*/, 23];
                case 12:
                    hubInfo = {
                        url: ((_l = links.find(function (link) { return link.Id === "ShellLogicFlows" /* FirstPartyWorkloadIds.Flow */; })) === null || _l === void 0 ? void 0 : _l.Url) || '',
                        appName: '',
                    };
                    return [3 /*break*/, 23];
                case 13:
                    hubInfo = {
                        url: ((_m = links.find(function (link) { return link.Id === "ShellClipchamp" /* FirstPartyWorkloadIds.Clipchamp */; })) === null || _m === void 0 ? void 0 : _m.Url) || '',
                        appName: '',
                    };
                    return [3 /*break*/, 23];
                case 14:
                    hubInfo = {
                        url: ((_o = links.find(function (link) { return link.Id === "ShellLists" /* FirstPartyWorkloadIds.Lists */; })) === null || _o === void 0 ? void 0 : _o.Url) || '',
                        appName: '',
                    };
                    return [3 /*break*/, 23];
                case 15:
                    hubInfo = {
                        url: ((_p = links.find(function (link) { return link.Id === "ShellAdmin" /* FirstPartyWorkloadIds.Admin */; })) === null || _p === void 0 ? void 0 : _p.Url) || '',
                        appName: '',
                    };
                    return [3 /*break*/, 23];
                case 16:
                    hubInfo = {
                        url: 'https://copilot.microsoft.com/',
                        appName: '',
                    };
                    return [3 /*break*/, 23];
                case 17:
                    hubInfo = {
                        url: window.location.origin + '/pages/',
                        appName: '',
                    };
                    return [3 /*break*/, 23];
                case 18:
                    url = (_q = links.find(function (link) { return link.Id === 'Shell' + tileID; })) === null || _q === void 0 ? void 0 : _q.Url;
                    if (!!url) return [3 /*break*/, 20];
                    return [4 /*yield*/, fetchThirdPartyWorkloads()];
                case 19:
                    thirdPartyWorkloads = _w.sent();
                    url = (_r = thirdPartyWorkloads.find(function (link) { return link.Id === tileID; })) === null || _r === void 0 ? void 0 : _r.Url;
                    _w.label = 20;
                case 20:
                    if (!!url) return [3 /*break*/, 22];
                    return [4 /*yield*/, fetchWorkspaces()];
                case 21:
                    workspaces = _w.sent();
                    allAppsWorkspace = (_t = (_s = workspaces === null || workspaces === void 0 ? void 0 : workspaces.result) === null || _s === void 0 ? void 0 : _s.workspaces) === null || _t === void 0 ? void 0 : _t.find(function (workspace) { return workspace.id === WORKSPACE_ID.allApps; });
                    url = (_u = allAppsWorkspace === null || allAppsWorkspace === void 0 ? void 0 : allAppsWorkspace.apps.find(function (app) { return app.servicePrincipalId === tileID; })) === null || _u === void 0 ? void 0 : _u.redirectUrl;
                    _w.label = 22;
                case 22:
                    hubInfo = {
                        url: url || '',
                        appName: '',
                    };
                    return [3 /*break*/, 23];
                case 23: return [2 /*return*/, hubInfo];
            }
        });
    });
}
//# sourceMappingURL=launchModuleById.js.map